// extracted by mini-css-extract-plugin
export default {"parametersHeading":"ParameterSettingsMenu-module__parametersHeading--hPr05"};